"use client";

import { Gauge, MousePointerClick, Target, TrendingUp } from "lucide-react";

import { CcButton } from "@/components/ui/CcButton";

import type { SemSubpageCopy } from "./sem-page-copy";
import type { SemProfitProjection } from "./sem-profit-projection";

type CcSemProfitResultsPanelProps = {
  copy: SemSubpageCopy["profitCalculator"];
  result: SemProfitProjection;
  money: Intl.NumberFormat;
  number: Intl.NumberFormat;
  ratio: Intl.NumberFormat;
};

export function CcSemProfitResultsPanel({
  copy,
  result,
  money,
  number,
  ratio,
}: CcSemProfitResultsPanelProps) {
  return (
    <div className="cc-sem-profit-results cc-traffic__result" aria-live="polite">
      <p className="cc-sem-profit-results__eyebrow">{copy.resultEyebrow}</p>

      <article className="cc-sem-profit-results__hero">
        <Target className="cc-sem-profit-results__hero-icon" aria-hidden="true" />
        <span>{copy.breakEvenLabel}</span>
        <strong>{money.format(result.breakEvenCpc)}</strong>
        <small>{copy.breakEvenSub}</small>
      </article>

      <div className="cc-sem-profit-results__grid">
        <article>
          <TrendingUp aria-hidden="true" />
          <span>{copy.roasLabel}</span>
          <strong>{ratio.format(result.valuePerAdKrona)}×</strong>
        </article>
        <article>
          <Gauge aria-hidden="true" />
          <span>{copy.cpaLabel}</span>
          <strong>{money.format(result.costPerCustomer)}</strong>
        </article>
        <article>
          <MousePointerClick aria-hidden="true" />
          <span>{copy.clicksLabel}</span>
          <strong>{number.format(Math.round(result.clicks))}</strong>
        </article>
      </div>

      <dl className="cc-sem-profit-results__funnel">
        <div>
          <dt>{copy.leadsLabel}</dt>
          <dd>{number.format(Math.round(result.leads))}</dd>
        </div>
        <div>
          <dt>{copy.customersLabel}</dt>
          <dd>{number.format(Math.round(result.customers))}</dd>
        </div>
      </dl>

      <div className="cc-sem-profit-results__cta">
        <CcButton
          bookCallPopup
          bookCallVariant="sem"
          label={copy.cta}
          expand
          expandCompact
        />
      </div>

      <p className="cc-traffic__footnote">{copy.footnote}</p>
    </div>
  );
}
